import { QueryClient, isHandledError } from "@pharmupp/p3-front-commons"

const retryHandler = (failureCount: number, error: unknown) => {
  if (isHandledError(error) && error.statusCode >= 500) {
    return failureCount < 3
  }
  return false
}

const secureQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: retryHandler,
    },
    mutations: {
      retry: retryHandler,
    },
  },
})

export { secureQueryClient }
